import { gql } from "apollo-boost";

export const MEET_SESSION_MERGE_ADD = gql`
  mutation meetSessionMerge(
    $number: Int
    $meetId: Int
    $name: String!
    $date: Date!
    $time: String!
    $updateSource: String!
  ) {
    meetSessionMerge(
      meetData: {
        number: $number
        name: $name
        meetId: $meetId
        date: $date
        time: $time
        updateSource: $updateSource
      }
    ) {
      node {
        number
        seqno
        meetId
        name
        date
        time
        updateDate
        updateSource
      }
    }
  }
`;
export const MEET_SESSION_MERGE_EDIT = gql`
  mutation meetSessionMerge(
    $number: Int
    $meetId: Int
    $name: String!
    $seqno: Int
    $date: Date!
    $time: String!
    $updateSource: String!
  ) {
    meetSessionMerge(
      meetData: {
        number: $number
        name: $name
        meetId: $meetId
        date: $date
        time: $time
        seqno: $seqno
        updateSource: $updateSource
      }
    ) {
      node {
        number
        seqno
        meetId
        name
        date
        time
        updateDate
        updateSource
      }
    }
  }
`;
export const MEET_SESSION_DELETE = gql`
  mutation meetSessionDelete($seqno: Int!) {
    meetSessionDelete(seqno: $seqno) {
      status
    }
  }
`;
